import React, { Suspense } from 'react';
import { Loading } from './components/loading';
import IRoute from './interface/IRoute';
import { Manufacturer } from './pages/third-parties/manufacturer/manufacturer';

const LazySigninPage = React.lazy(() => import('./pages/siginin/signin.component'));
const LazyDashboardPage = React.lazy(() => import('./pages/dashboard/dashboard.component'));
const LazyOperationsPage = React.lazy(() => import('./pages/operations/operations'));
const LazyOperationsBetaPage = React.lazy(() => import('./pages/operations-beta/operations'));
const LazyOperationsCaseInfoPage = React.lazy(() => import('./pages/case/case.component'));
const LazyOperationsTreatmentDesignDetailPage = React.lazy(
  () => import('./pages/case/treatment-details/treatment-design-detail.component'),
);
const LazyDentistsPage = React.lazy(() => import('./pages/dentists/dentist.component'));
const LazyPracticesPage = React.lazy(() => import('./pages/organization/organization.component'));
const LazyBillsPage = React.lazy(() => import('./pages/bills/bill.component'));
const LazyPaymentsPage = React.lazy(() => import('./pages/payments/payment.component'));
const LazyDiscountsPage = React.lazy(() => import('./pages/discounts/discount.component'));
const LazyDiscountOperationPage = React.lazy(() => import('./pages/discounts/discount.operations'));
const LazyProfile = React.lazy(() => import('./pages/profile/profile'));
const LazyDesigner = React.lazy(() => import('./pages/third-parties/designer/designer'));
const LazySpecialist = React.lazy(() => import('./pages/third-parties/specialist/specialist'));
const EducationContentPage = React.lazy(() => import('./pages/education-content/education-content'));
const EducationContentDetailPage = React.lazy(
  () => import('./pages/education-content/education-content-detail/education-content-detail'),
);

const LazyDentistsProfileCasesComponent = React.lazy(() => import('./pages/dentists-profile-cases/dentist-cases'));
const LazyReleaseNotesPage = React.lazy(() => import('./pages/release-notes/release-notes'));
const LazyGroupsPage = React.lazy(() => import('./pages/groups/groups'));

export const unProctedRoutes: IRoute[] = [
  {
    path: '/signin',
    exact: true,
    name: 'Signin Page',
    key: 'signin_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazySigninPage />
      </Suspense>
    ),
  },
];

export const protectedRoutes: IRoute[] = [
  {
    path: '/',
    exact: true,
    name: 'Dashboard Page',
    key: 'dashboard_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyDashboardPage />
      </Suspense>
    ),
  },
  {
    path: '/operations',
    exact: true,
    name: 'Operations Page',
    key: 'operations_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyOperationsPage />
      </Suspense>
    ),
  },
  {
    path: '/operations-beta',
    exact: true,
    name: 'Operations Beta',
    key: 'operations_beta',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyOperationsBetaPage />
      </Suspense>
    ),
  },
  {
    path: '/operations/:caseId',
    exact: true,
    name: 'Operations_Case_Details',
    key: 'operations_case_details',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyOperationsCaseInfoPage />
      </Suspense>
    ),
  },
  {
    path: '/operations/:caseId/design/:designId',
    exact: true,
    name: 'Operations_Treatment_Detail_Design',
    key: 'operations_treatment_detail_design',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyOperationsTreatmentDesignDetailPage />
      </Suspense>
    ),
  },
  {
    path: '/operations/case-listing/:caseStatus',
    exact: true,
    name: 'Case_Listing',
    key: 'case_listing',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyOperationsPage />
      </Suspense>
    ),
  },
  {
    path: '/dentists',
    exact: true,
    name: 'Dentists Page',
    key: 'dentists_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyDentistsPage />
      </Suspense>
    ),
  },
  {
    path: '/dentists/:id',
    exact: true,
    name: 'Dentist_Profile_Page',
    key: 'dentist_profile_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyProfile />
      </Suspense>
    ),
  },
  {
    path: '/dentists/:id/:status',
    exact: true,
    name: 'Dentist_Profile_Cases_Page',
    key: 'dentist_profile_cases_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyDentistsProfileCasesComponent />
      </Suspense>
    ),
  },
  {
    path: '/practices',
    exact: true,
    name: 'Pactices Page',
    key: 'pactices_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyPracticesPage />
      </Suspense>
    ),
  },
  {
    path: '/bills',
    exact: true,
    name: 'Bills_Page',
    key: 'bills_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyBillsPage />
      </Suspense>
    ),
  },
  {
    path: '/payments',
    exact: true,
    name: 'Payments_Page',
    key: 'payments_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyPaymentsPage />
      </Suspense>
    ),
  },
  {
    path: '/discounts',
    exact: true,
    name: 'Discounts_Page',
    key: 'discount_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyDiscountsPage />
      </Suspense>
    ),
  },
  {
    path: '/discount',
    exact: true,
    name: 'Create_Discount_Page',
    key: 'create_discount_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyDiscountOperationPage />
      </Suspense>
    ),
  },
  {
    path: '/discount/:discountId',
    exact: true,
    name: 'Edit_Discount_Page',
    key: 'edit_discount_page',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyDiscountOperationPage />
      </Suspense>
    ),
  },
  {
    path: '/designer',
    exact: true,
    name: 'third-party-designer',
    key: 'third-party-designer',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyDesigner />
      </Suspense>
    ),
  },
  {
    path: '/manufacturer',
    exact: false,
    name: 'third-party-manufacturer',
    key: 'third-party-manufacturer',
    component: () => <Manufacturer />,
  },
  {
    path: '/specialist',
    exact: true,
    name: 'third-party-specialist',
    key: 'third-party-specialist',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazySpecialist />
      </Suspense>
    ),
  },
  {
    path: '/education-content',
    exact: true,
    name: 'Education Content',
    key: 'education-content',
    component: () => (
      <Suspense fallback={<Loading />}>
        <EducationContentPage />
      </Suspense>
    ),
  },
  // {
  //   path: '/education-content/impersonate/:dentistId',
  //   exact: true,
  //   name: 'Education Content - Impersonate dentist',
  //   key: 'education-content-impersonate',
  //   component: () => (
  //     <Suspense fallback={<Loading />}>
  //       {/* <EducationContentPage /> */}
  //     </Suspense>
  //   ),
  // },
  {
    path: '/education-content/content/:contentId',
    exact: true,
    name: 'Education Content - Detailed',
    key: 'education-content-detailed',
    component: () => (
      <Suspense fallback={<Loading />}>
        <EducationContentDetailPage />
      </Suspense>
    ),
  },
  {
    path: '/release-notes',
    exact: true,
    name: 'Release notes',
    key: 'release-notes',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyReleaseNotesPage />
      </Suspense>
    ),
  },
  {
    path: '/groups',
    exact: false,
    name: 'Groups',
    key: 'groups',
    component: () => (
      <Suspense fallback={<Loading />}>
        <LazyGroupsPage />
      </Suspense>
    ),
  },
];
